'use client';
import AboutUsPic from 'assets/images/aboutUs/aboutUs.jpg';
import Image from 'next/image';
import Styles from './aboutUs.module.scss';
import { MobileHeaderComp } from 'components';
import logo from 'assets/images/logo.png';

const AboutUsComp = () => {
    return (
        <>
            <MobileHeaderComp title="درباره تیک سبز" />
            <div className={`${Styles['about-us']} flex-column items-center bp-md-flex-row`}>
                <Image
                    src={AboutUsPic}
                    alt="about us page picture"
                    className={`${Styles['picture']} m-auto w-100`}
                    objectFit="contain"
                />
                <div className="flex-1 flex-column g-3">
                    <div>
                        <h3 className="mb-2 t-500 t-h2 d-pre-md-none">درباره پلتفرم تیک سبز</h3>
                        <Image src={logo} alt="تیک سبز" width={100} height={100} className="d-md-none mb-2" />
                        <p className={`${Styles['paragraph']} t-h3`}>
                            تیک سبز؛ مرجع تخصصی معرفی فروشگاه‌ها و تأمین‌کنندگان معتبر
                        </p>
                        <p className={`${Styles['paragraph']} t-h3`}>
                            تیک سبز بستری برای ارتباط مستقیم و بدون واسطه بین خریداران با فروشگاه‌ها، عمده‌فروشان و
                            تولیدکنندگان است.
                        </p>
                    </div>
                    <div>
                        <h3 className="mb-2 t-500 t-h2">در تیک سبز چه چیزی پیدا می‌کنید؟</h3>
                        <div className={`${Styles['paragraph']} t-h3`}>
                            <p className="t-p1">
                                ما فقط پذیرای فروشگاه‌ها و کسب‌وکارهای حرفه‌ای هستیم. در اینجا خبری از آگهی‌های شخصی یا
                                کالای دست‌دوم نیست. تمرکز ما معرفی محصولات نو، خدمات فروشگاهی و تأمین‌کنندگان معتبر است.
                            </p>
                        </div>
                    </div>
                    <div>
                        <h3 className="mb-2 t-500 t-h2">🔹 چه کسانی می‌توانند در تیک سبز فعالیت کنند؟</h3>
                        <div className={`${Styles['paragraph']} t-h3`}>
                            <p className="t-p1">فروشگاه‌های حضوری</p>
                            <p className="t-p1">عمده‌فروشان و بنکداران</p>
                            <p className="t-p1">تولیدکنندگان و کارگاه‌ها</p>
                            <p className="t-p1">شرکت‌ها و برندهای تولیدی</p>
                            <p className="t-p1">کارخانه‌ها و تأمین‌کنندگان صنعتی</p>
                            <p className="t-p1">فروشگاه‌های اینترنتی و پلتفرم‌های فروش آنلاین</p>
                            <p className="t-p1">
                                هر کسب‌وکاری که محصول یا خدمات قابل ارائه دارد، می‌تواند در تیک سبز ثبت‌نام کند و
                                آگهی‌های خود را منتشر کند.
                            </p>
                        </div>
                    </div>
                    <div>
                        <h3 className="mb-2 t-500 t-h2">نکات مهم:</h3>
                        <div className={`${Styles['paragraph']} t-h3`}>
                            <p className="t-p1">
                                پلتفرم اطلاع‌رسانی: تیک سبز صرفاً بستری برای انتشار آگهی است و هیچ‌گونه دخالت یا
                                مسئولیتی در فرآیند معامله بین خریدار و فروشنده ندارد.
                            </p>
                            <p className="t-p1">شفافیت: مسئولیت خرید و توافق نهایی بر عهده طرفین معامله است.</p>
                            <p className="t-p1">
                                امنیت: اگر آگهی مشکوکی مشاهده کردید، لطفاً از طریق بخش «گزارش آگهی» به ما اطلاع دهید تا
                                سریعاً بررسی کنیم.
                            </p>
                            <p className="t-p1">تیک سبز؛ انتخاب حرفه‌ای‌ها برای خریدی مطمئن.</p>
                        </div>
                    </div>
                    {/* <div>
                        <h3 className="mb-2 t-500 t-h2">شماره تماس</h3>
                        <p className={`${Styles['paragraph']} t-h3`}>
                            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است
                            چاپگرها و متون بلکه روزنامه و مجله
                        </p>
                    </div> */}
                </div>
            </div>
        </>
    );
};

export default AboutUsComp;
